import { render, staticRenderFns } from "./examineplantopic.vue?vue&type=template&id=0adf86ac&"
import script from "./examineplantopic.vue?vue&type=script&lang=js&"
export * from "./examineplantopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports